export default "__VITE_ASSET__CJNN564q__"